import React from 'react';
import HashLoader from "react-spinners/HashLoader";

const LoadingScreen = ({ fullScreen = true }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: fullScreen ? '100vh' : '200px',
      width: '100%'
    }}>
      <HashLoader color="#1B4480" size={80} />
    </div>
  );
};

export default LoadingScreen;
